import { useEffect } from "react";
import { useLocation } from "react-router-dom";

const TITLES = {
  "/": "Home",
  "/services": "Services",
  "/pricing": "Pricing",
  "/gallery": "Gallery",
  "/about": "About",
  "/contact": "Contact",
  "/blog": "Blog",
  "/shop": "Pet Shop",
  "/grooming": "Grooming & Spa",
  "/brands": "Brands",
  "/breeds": "Shop by Breed",
  "/account": "My Account",
  "/shop/all": "All Products",
  "/checkout": "Checkout",
  "/track-order": "Track Order",
  "/admin/products": "Products",
  "/admin/orders": "Orders",
  "/admin/login": "Admin Login",
  "/admin": "Dashboard",
  "/admin/bookings": "Bookings",
  "/admin/enquiries": "Enquiries",
  "/admin/reminders": "Reminders",
  "/admin/tasks": "Tasks",
  "/admin/blog": "Blog",
  "/admin/reports": "Reports",
  "/admin/team": "Team",
};

export default function RouteTitle() {
  const { pathname } = useLocation();
  useEffect(() => {
    const exact = TITLES[pathname];
    const isAdmin = pathname.startsWith("/admin");
    const fallback = isAdmin ? "Admin" : "BarknFurs";
    const page = exact || fallback;
    const suffix = isAdmin
      ? "BarknFurs Admin"
      : "BarknFurs Grooming Studio";
    document.title = `${page} — ${suffix}`;
  }, [pathname]);
  return null;
}
